<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="580px"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
      class="edit-container-dialog"
    >
      <span slot="title" class="d-flex align-items-center">
        <i
          class="el-icon-edit-outline mr-2"
          style="color: #409eff;font-size: 20px;"
        />

        <span style="color: #1e293b;">
          {{
            shipmentContainerCode
              ? $l('btn_edit_container') || '编辑货柜'
              : $l('btn_add_container') || '新增货柜'
          }}
        </span>
      </span>

      <Main
        ref="main"
        :shipmentContainerCode="shipmentContainerCode"
        :shipmentCode="shipmentCode"
        @close="close"
        @reload="$emit('reload')"
      />

      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          plain
          @click="$refs.main.confirm()"
        >
          <i class="el-icon-plus" />
          {{ $l('btn_confirm_save') || '确认保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    shipmentContainerCode: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.edit-container-dialog {
  .el-dialog__header {
    background: transparent;
    border-bottom: none;
    padding: 12px 20px !important;
  }
  .el-dialog__footer {
    padding: 12px 20px 16px;
    background: #f8fafc;
    border-top: 1px solid #f1f5f9;
  }
}
</style>
